import countryCode from "./countryCode/countryCode.vue";
import { mobileVerificationCode, emailVerificationCode } from "../service/user";
import Verify from "@/components/verifition/Verify";
import { onInputRange } from "@/utils/util.js";
const defaultTime = 60;
export default {
  data() {
    return {
      text: "",
      time: defaultTime,
      onInputRange,
      disabled: false,
      form: {
        email: "",
        mobile: "",
        verificationCode: ""
      }
    };
  },
  props: {
    accountType: {
      default() {
        return "MOBILE";
      }
    },
    showText: {
      default() {
        return true;
      }
    },
    mode: {
      default() {
        return "REGISTER";
      }
    },
    exist: {
      default() {
        return false;
      }
    },
    value: {}
  },
  methods: {
    onEnter() {
      this.$emit("onEnter");
    },
    //接收手机号和国家地区码
    emitMobileCode(data) {
      console.log("data----", data);
    },
    //清除获取验证码定时器
    clearVerificationCode() {
      this.disabled = false;
      this.time = defaultTime;
      this.newText = $t("t09mz15", "获取验证码");
      clearInterval(this.interval);
      this.interval = null;
    },
    async start() {
      if (!this.disabled) {
        this.disabled = true;
        this.interval = setInterval(() => {
          this.time -= 1;
          this.newText = `${this.time}${$t('gct4ua6', '秒后重新获取')}`;
          if (this.time <= 0) {
            this.disabled = false;
            this.time = defaultTime;
            this.newText = $t("t09mz15", "获取验证码");
            clearInterval(this.interval);
            this.interval = null;
          }
        }, 1000);
      }
    },
    clean() {
      if (this.accountType === "MOBILE" && !this.exist) {
        this.$refs["form"].resetFields();
        this.$refs.countryCode.clean();
      } else {
        this.$refs["form"].resetFields();
      }
    },
    // 仅清理验证码输入、倒计时和校验状态，保留当前手机号/邮箱展示值。
    clearVerificationState() {
      this.clearVerificationCode();
      if (this.value) {
        this.value.verificationCode = "";
      }
      if (this.$refs.form && typeof this.$refs.form.clearValidate === "function") {
        this.$refs.form.clearValidate();
      }
      if (this.$refs.countryCode && this.$refs.countryCode.$refs && this.$refs.countryCode.$refs.form && typeof this.$refs.countryCode.$refs.form.clearValidate === "function") {
        this.$refs.countryCode.$refs.form.clearValidate();
      }
    },
    validate(validate) {
      if (this.accountType === "MOBILE" && !this.exist) {
        return this.$refs.form.validate(validate) && this.$refs.countryCode.validate();
      } else {
        return this.$refs.form.validate(validate);
      }
    },
    getCode() {
      this.$refs.verify.show();
    },
    async success(value) {
      // console.log("获取验证码----", this.value);
      if (this.accountType === "MOBILE") {
        // console.log("获取验证码的手机号----", this.value.mobile);
        const res = await mobileVerificationCode(this.value.mobile, value.captchaVerification, this.mode, this.value.mobileAreaCode);
        if (res.data && res.data.result === 0) {
          this.start();
        } else if (res.data.result === 10007) {
          //抛出异常
          this.$emit("noMobileEmail");
        }
      } else {
        const res = await emailVerificationCode(this.value.email, value.captchaVerification, this.mode);
        if (res.data && res.data.result === 0) {
          this.start();
        } else if (res.data.result === 10012) {
          //抛出异常
          this.$emit("noMobileEmail");
        }
      }
    }
  },
  watch: {
    canSend(val) {
      if (!val) {
        this.value.verificationCode = "";
      }
    }
  },
  computed: {
    // 重复定义newText目的是切换语言时可以不刷新页面就实时切换（主要给立即绑定移动端使用，pc切换语言时会刷新页面）
    newText: {
      get() {
        return $t("t09mz15", "获取验证码");
      },
      set(val) {
        this.text = val;
      }
    },
    ruleValidate() {
      const rules = {
        email: [{
          required: true,
          message: $t("irio214", "邮箱必填"),
          // message: "邮箱必填",
          trigger: "blur"
        }, {
          pattern: /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
          message: $t("venleq7", "邮箱格式不正确"),
          // message: "邮箱格式有误",
          trigger: "blur"
        }],
        verificationCode: [{
          required: true,
          message: $t("gvicb25", "验证码必填"),
          trigger: "blur,change"
        }, {
          pattern: /\d{6}/,
          message: $t("hf7bgs8", "验证码为6位数字"),
          trigger: "blur,change"
        }]
      };
      return rules;
    },
    canSend() {
      if (this.accountType === "MOBILE") {
        let mobile;
        if (this.value.mobile && this.value.mobile.indexOf("*") > -1) {
          mobile = this.value.mobile.split("*").join("");
        }
        return /^[0-9 || *]{1,11}$/.test(mobile || this.value.mobile);
      } else {
        return /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(this.value.email);
      }
    }
  },
  components: {
    Verify,
    countryCode
  }
};